import useDebugInfo from '../hooks/useDebugInfo';
import { DebugCopyButton } from './DebugCopyButton';
import styles from './DebugFab.module.css';

export const DebugInfoPanel: React.FC<DebugInfoPanelProps> = ({ onClose }) => {
    const groups = useDebugInfo();

    return (
        <div className={styles.panel} role="dialog" aria-label="Debug info">
            <div className={styles.panelHeader}>
                <span className={styles.panelTitle}>Debug info</span>
                <button type="button" className={styles.closeButton} onClick={onClose} title="Close">
                    ×
                </button>
            </div>
            <div className={styles.panelBody}>
                {groups.map((group) => (
                    <div key={group.title} className={styles.group}>
                        <div className={styles.groupTitle}>{group.title}</div>
                        {group.rows.map((row) => (
                            <div key={`${group.title}-${row.label}`} className={styles.row}>
                                <span className={styles.rowLabel}>{row.label}</span>
                                <span className={row.value ? styles.rowValue : styles.rowValueEmpty}>
                                    {row.value ?? '—'}
                                </span>
                                <DebugCopyButton text={row.value} />
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};

interface DebugInfoPanelProps {
    onClose: VoidFunction;
}
